import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { afterItems, beforeItems } from '../data/painPoints';
export function BeforeAfterSection() {
  return <section className="w-full bg-cream-100 py-14 sm:py-20" data-id="element-43" data-mp="po267dw2a8nm">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-44" data-mp="ppn2b7y0xznl">
        <h2 className="text-center font-display text-[25px] font-bold leading-[1.15] text-navy-900 sm:text-4xl" data-id="element-45" data-mp="kwaf928zu0wy">
          From a dentist who adjusts by chasing marks…{' '}
          <em className="not-italic text-gold-600" data-id="element-46" data-mp="unok7pjprsxh">
            to a professional who analyzes the case with a system.
          </em>
        </h2>

        <div className="mt-9 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-47" data-mp="18kk6ijoz7gvh">
          {/* BEFORE */}
          <div className="flex h-full flex-col overflow-hidden rounded-3xl border border-clinical-red/25 bg-white shadow-card" data-id="element-48" data-mp="13ocx2gxdfn8s">
            <div className="flex items-center justify-center gap-2 bg-clinical-red px-4 py-3.5" data-id="element-49" data-mp="35ey5zu1txve1">
              <XIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-50" data-mp="36ojl5gkvwyha" />
              <h3 className="text-[13px] font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-51" data-mp="36qcs6wzetkpt">
                Before
              </h3>
            </div>
            <ul className="flex-1 space-y-3 p-4 sm:p-5" data-id="element-52" data-mp="3gmfsdxapb9a4">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-53" data-mp="3ldo1es84csmr">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-clinical-red/10 text-clinical-red" aria-hidden="true" data-id="element-54" data-mp="3pf1792b7ovto">
                    <XIcon className="h-3 w-3" data-id="element-55" data-mp="37jhqt1xhbzv" />
                  </span>
                  <span className="text-[14.5px] leading-snug text-navy-800/85" data-id="element-56" data-mp="86w1v61f04yr">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* WITH OCCLUSION 360 */}
          <div className="flex h-full flex-col overflow-hidden rounded-3xl border-2 border-clinical-green/40 bg-white shadow-lift" data-id="element-57" data-mp="29zahfyghkxc0">
            <div className="flex items-center justify-center gap-2 bg-clinical-green px-4 py-3.5" data-id="element-58" data-mp="21xtdrcfuhy67">
              <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-59" data-mp="1x0kwde2ity60" />
              <h3 className="text-[13px] font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-60" data-mp="2bwiqyrwsqug4">
                With Occlusion 360™
              </h3>
            </div>
            <ul className="flex-1 space-y-3 p-4 sm:p-5" data-id="element-61" data-mp="2kvxg9o188yz1">
              {afterItems.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-62" data-mp="2fy484pgd5uw4">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-clinical-green/10 text-clinical-green" aria-hidden="true" data-id="element-63" data-mp="2um8sryyz8ghj">
                    <CheckIcon className="h-3 w-3" data-id="element-64" data-mp="33m5bljyoql4o" />
                  </span>
                  <span className="text-[14.5px] font-medium leading-snug text-navy-900" data-id="element-65" data-mp="2zlbkkhpy4q7k">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-66" data-mp="3n8yqt9m0tp08">
          <CTAButton label="I want to analyze cases with a system" subline="Instant access · One-time payment · 7-day guarantee" data-id="element-67" data-mp="3n6m8uwg9jen6" />
        </div>
      </div>
    </section>;
}